import React from 'react'

const Doi = (props) => {
    return (
        <a rel="noreferer noopener" className="pending">
            {props.text}
        </a>
    )
}

export default Doi;


// WEBPACK FOOTER //
// ./src/components/doi.js